import { PageComponent } from "@aptus/frontend-core";
import { Select } from "components/input/input";
import { MiddleStepFooter, StepSection } from "components/stepSection/stepSection";
import {
	useAuthentication,
	useRoutes,
} from "domains";
import { RegisterInput } from "hooks/authentication/models/authenticationInput";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const QuestionsStep: PageComponent = () => {
	/*
	const {
		formState, watch,
	} = useFormContext<RegisterInput>();
	*/

	const { t } = useTranslation();

	const { routes } = useRoutes();
	const {
		isRegistrationStepValid,
	} = useAuthentication();

	const {
		register, formState, getValues, watch,
	} = useFormContext<RegisterInput>();

	const daysPerWeekByFootToOption = (value: string) => (<option key={value} value={value} selected={getValues("daysPerWeekByFoot") === value}>{t(`daysPerWeekByFootInput.values.${value}`)}</option>);

	return (
		<StepSection>
			<Select
				{...register("daysPerWeekByFoot")}
				id="daysPerWeekByFoot"
				label={t("daysPerWeekByFootInput.label")}
				error={(formState.errors.daysPerWeekByFoot?.message)}
			>
				<option selected style={{ display: "none" }}>{t("daysPerWeekByFootInput.defaultOption")}</option>
				{Array.from({ length: 6 }, (_, index) => (daysPerWeekByFootToOption(index.toString())))}
			</Select>
			<MiddleStepFooter
				previousStepHref={routes.register.stepFive}
				currentStepHref={routes.register.stepSix}
				nextStepHref={routes.register.stepSeven}
				isValid={isRegistrationStepValid(["daysPerWeekByFoot"], watch())}
			/>
		</StepSection>
	);
};
